import {ItemCategoryTemplateDto} from "../../model/item-containers-models/itemCategoryTemplateDto";
import {ItemRichTextDto} from "../../model/item-containers-models/itemRichTextDto";
import {ItemViewTemplateDto} from "../../model/item-containers-models/itemViewTemplateDto";
import {
  ITEMCONTAINER_ELEM_TYPE_VALUE_CATEGORY,
  ITEMCONTAINER_ELEM_TYPE_VALUE_TEXT,
  ITEMCONTAINER_ELEM_TYPE_VALUE_VIEW
} from "../../utils/itemContainers";

export const itemIsView = (
  v: ItemCategoryTemplateDto | ItemRichTextDto | ItemViewTemplateDto
): v is ItemViewTemplateDto => v.type === ITEMCONTAINER_ELEM_TYPE_VALUE_VIEW;

export const itemIsText = (v: ItemCategoryTemplateDto | ItemRichTextDto | ItemViewTemplateDto): v is ItemRichTextDto =>
  v.type === ITEMCONTAINER_ELEM_TYPE_VALUE_TEXT;

export const itemIsCategory = (
  v: ItemCategoryTemplateDto | ItemRichTextDto | ItemViewTemplateDto
): v is ItemCategoryTemplateDto => v.type === ITEMCONTAINER_ELEM_TYPE_VALUE_CATEGORY;
